import { connect } from 'react-redux';
import TwoFAModal from './TwoFAModal';
import { enable2fa, load2faQR } from '../../../../redux/actions/auth';

const mapStateToProps = (state) => {
  return {
    qrCode: state.auth.qrCode,
    status: state.auth.status,
  };
};

const mapDispatchToProps = {
  load2faQR,
  enable2fa,
};

export default connect(mapStateToProps, mapDispatchToProps)(TwoFAModal);
